/* eslint-disable eqeqeq */
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { Set_SalesQuotation_Checkbox } from "../SliceSalesQuotation";
import { fKeyTabInput } from "../../../Utility/Utilitys";
import GCToggleTableSearch from "../../../Component/Common/ReuseableComponent/GCToggleTableSearch";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  CmpSelectField,
  CmpSelectArrField,
  CmpInputFieldGroup,
  CmpInputField,
  CmpCheckboxField,
  CmpTypographyField,
  CmpButtonKWithIcon,
} from "../../../Component/Common/ToolBox/ToolBox";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import Grid from "@mui/material/Grid";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import {
  CmpInputFieldGroupV1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";

export default function GCContent({
  sTransItemStockObj,
  xTransItemStockShow,
  fGrossAmt,
  bufferObj,
  fonClickInputFocus,
  fonClickInputBlur,
  fOpenContentItemSearchModalKey,
  // fOnChangeSelectUnit,
  fonChangeCheckBoxFoc,
  taxDept1,
  taxDept2,
  ItemUnit,
  fonChangeInputQty,
  fonChangeInputItemName,
  fonChangeInputUnit,
  fonChangeInputUnitRateFC,
  fUnitRateFCSave_onKeyUp,
  fonChangeInputLDisc,
  fonChangeInputLDiscAmt,
  fonChangeInputExcise,

  xNarrArr,
  sErrorMsg,
  vRdxSalesQuotationHead,
  xItemStock,
  xcolumnsDropdownSearch,
  xrowDropdownSearch,
  xOnCellKeyDown,
  xOnRowClick,
  xToggleDropdown,
  xhandleClick,
  xMediaQuery,
  fFocusShowSalesHistoryGrid,
  xinputRef,
  xData,
  xOnChange,
  xDropdownObj,
  xOnKeyUp,

  //narration
  fonChangeInputNarration,
  fNarrationKeyEnter,
  xNarrationToggleDropdown,
  xrowDropdownNarrationSearch,
  xcolumnsDropdownNarrationSearch,
  xOnCellKeyNarrationDown,
  xOnRowNarrationClick,
}) {
  const dispatch = useDispatch();
  const vRdxCheckbox = useSelector(
    (state) => state?.SliceSalesQuotation?.value?.SalesQuotationCheckbox
  );
  const vModelCheckboxArr = [
    { name: "UnitRateLC", rdxName: vRdxCheckbox.UnitRateLC },
    { name: "LDisc", rdxName: vRdxCheckbox.LDisc },
    { name: "TDisc", rdxName: vRdxCheckbox.TDisc },
    { name: "Foc", rdxName: vRdxCheckbox.Foc },
    { name: "Excise", rdxName: vRdxCheckbox.Excise },
    { name: "Taxable", rdxName: vRdxCheckbox.Taxable },
    { name: "Narration", rdxName: vRdxCheckbox.Narration },
    { name: "ItemCode", rdxName: vRdxCheckbox.ItemCode },
    { name: "PackQty", rdxName: vRdxCheckbox.PackQty },
  ];
  const [sIsChecked, setIsChecked] = useState(false); //ALL CHECKED
  const [sWmsInnCheckbox, setSalesQuotationCheckbox] = useState(vRdxCheckbox);

  const [sOpenContentModal, setOpenContentModal] = useState(false);
  const [sOpenModalName, setOpenModalName] = useState(""); // MODAL OPEN

  const fModalContentOpen = (e, ModalName) => {
    setOpenModalName(ModalName);
    setOpenContentModal(true);
  };

  const fModalContentClose = () => {
    setOpenContentModal(false);
  };

  const fIsAllChecked = (e) => {
    const iSCheck = e.target.checked;
  
    setIsChecked(iSCheck);
    const updatedObj = Object.keys(vRdxCheckbox).reduce((acc, key) => {
      acc[key] = iSCheck;
      return acc;
    }, {});

    // Update the state with the new object
    setSalesQuotationCheckbox(updatedObj);
    
  };

  const fSetCheckBox = (e) => {
    const nameValue = e.target.name;
    const iSCheck = e.target.checked;
    setSalesQuotationCheckbox((obj) => ({ ...obj, [nameValue]: iSCheck }));
  };

  useEffect(() => {
    dispatch(Set_SalesQuotation_Checkbox(sWmsInnCheckbox));
    const vIsAllTrue = Object.values(sWmsInnCheckbox).every(
      (value) => value === true
    );
    setIsChecked(vIsAllTrue);
  }, [dispatch, sWmsInnCheckbox]);

  return (
    <form
      className="Wms-sales-invoice-Content "
      id="SalesQuotationContentID"
      autoComplete="off"
    >
      <Grid
        container
        spacing={0.9}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          container
      
          textAlign={"end"}
          justifyContent={"end"}
        >
          
          <Grid item xs={12} sm={6} md={3} >
            <div className={"d-flex justify-content-end"}>
              <span
                className={
                  vRdxSalesQuotationHead.A_DocStat == "ENTER"
                    ? "d-flex justify-content-between align-items-center"
                    : "hide-content"
                }
              >
                {" "}
             
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Stock=" + sTransItemStockObj.RPStock}
                />{" "}
                &nbsp; &nbsp;
                {Number(sTransItemStockObj.MSP) > 0 ? (
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"MSP=" + sTransItemStockObj.MSP}
                  />
                ) : (
                  <></>
                )}
                &nbsp; &nbsp;
                {xTransItemStockShow >= 0 ? (
                  <>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={" CostPr=" + sTransItemStockObj.CostPr}
                    />
                    &nbsp;&nbsp;
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"LPRate=" + sTransItemStockObj.LPRate}
                    />{" "}
                  </>
                ) : (
                  <></>
                )}
                &nbsp; &nbsp;
               
              </span>
            </div>
          </Grid>
          <Grid item xs={3} sm={3} md={1}>
            <span
              className={
                vRdxSalesQuotationHead.A_DocStat == "ENTER"
                  ? "txt-overflow-wms"
                  : "hide-content"
              }
              title={xItemStock?.msp}
            >
              <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Value: " + xItemStock?.costpr}
                /> 
            </span>
          </Grid>
          <Grid item xs={3} sm={3} md={3}>
            <span
              className={
                vRdxSalesQuotationHead.A_DocStat == "ENTER"
                  ? "txt-overflow-wms"
                  : "hide-content"
              }
              title={xItemStock?.msp}
            >
              <CmpTypographyField
                xcomponent={"span"}
                xText={"MSP: " + xItemStock?.msp}
              />{" "}
            </span>
          </Grid>
          {!xMediaQuery&&( <Grid item xs={3} sm={3} md={3}>
            <MoreHorizOutlinedIcon
              onClick={(e) => {
                fModalContentOpen(e, "checkboxModal");
              }}
              className="form-label gnr-title-txt"
            />
          </Grid>)}
        </Grid>
        {/* {!xMediaQuery&&<Grid item xs={6} sm={2} md={0.5} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="S.No"
            xValue={bufferObj.B_Srno}
            xType={"text"} // text/number/password
            xName={"B_Srno"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsg.B_Srno === "" ? false : true}
            xErrorMessage={sErrorMsg.B_Srno}
            // xOnKeyUp={xKey}
          />
        </Grid>} */}

        <Grid item xs={6} sm={2} md={2} lg={1}className={vRdxCheckbox.ItemCode ? "lastkeyDetect " : "hide-content"}   >
          <CmpTextFieldV1
            xLabelText="Item Code"
            xValue={bufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsg.B_Itmcd === "" ? false : true}
            xErrorMessage={sErrorMsg.B_Itmcd}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={8}
          // sm={"auto"}
          // md={"auto"}
          // lg={"auto"}
          md={xToggleDropdown ? 7.5 : 5}
          className="lastkeyDetect dropDowntoggle"
        >
          <GCToggleSearchV1
            xLabelText="Item Name"
            xtabIndex={"101"}
            xName={"B_ItmName"}
            xType={"text"}
            xValue={bufferObj?.B_ItmName}
            xReadOnly={false}
            xOnChange={fonChangeInputItemName}
            xOnKeyUp={(e) => {
              fOpenContentItemSearchModalKey(e, "itemSearch");
            }}
            xError={sErrorMsg.B_ItmName === "" ? false : true}
            xErrorMessage={sErrorMsg.B_ItmName}
            xMediaQuery={xMediaQuery}
            xonClickbtn={xhandleClick}
            xrows={xrowDropdownSearch}
            xcolumns={xcolumnsDropdownSearch} //head
            xRowCellClick={xOnCellKeyDown}
            xRowClick={xOnRowClick}
            xToggle={xToggleDropdown}
            xData={xData}
            xOnChangeDropdownInput={xOnChange}
            xDropdownObj={xDropdownObj}
            xOnKeyUpDropdownInput={xOnKeyUp}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Qty"
            xtabIndex={"102"}
            xValue={bufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={false}
            xOnChange={fonChangeInputQty}
            xError={sErrorMsg.B_Qty === "" ? false : true}
            xErrorMessage={sErrorMsg.B_Qty}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "B_URateFc");
            }}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1.5} className="lastkeyDetect">
          <CmpSelectFieldV1
            xtabIndex={"103"}
            xLabelText="Unit"
            xValue={bufferObj.B_Unit}
            xOnChange={(e) => {
              fonChangeInputUnit(e, ItemUnit);
            }}
            xName={"B_Unit"}
            xData={ItemUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={sErrorMsg.B_Unit === "" ? false : true}
            xErrorMessage={sErrorMsg.B_Unit}
            xDisable={false}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
          />
        </Grid>
        {vRdxCheckbox.PackQty && <Grid item xs={4} sm={1} md={1}  className="lastkeyDetect">
         
           <CmpTextFieldV1
            xLabelText="PackQty"
              xSize="small"
            xtabIndex={"103"}
            xValue={bufferObj.B_PackQty}
            xType={"text"} // text/number/password
            xName={"B_PackQty"}
            xReadOnly={true}
            xOnChange={()=>{}}
            xError={false}
            xErrorMessage={""}
          
          />
        </Grid>}
        <Grid item xs={4} sm={2} md={1} lg={1} className={"lastkeyDetect"}>
          <CmpTextFieldV1
            xLabelText="BaseQty"
            xValue={bufferObj.B_BaseQty}
            xType={"text"} // text/number/password
            xName={"B_BaseQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsg.B_BaseQty == "" ? false : true}
            xErrorMessage={sErrorMsg.B_BaseQty}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid item xs={4} sm={2} md={2} lg={1.5} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Unit Rate FC"
            xtabIndex={"104"}
            xValue={bufferObj.B_URateFc}
            xType={"number"} // text/number/password
            xName={"B_URateFc"}
            xReadOnly={false}
            xOnChange={fonChangeInputUnitRateFC}
            xError={sErrorMsg.B_URateFc === "" ? false : true}
            xErrorMessage={sErrorMsg.B_URateFc}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            xOnKeyUp={(e) => fUnitRateFCSave_onKeyUp(e)}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={
            vRdxCheckbox.UnitRateLC ? "lastkeyDetect " : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="UnitRateLC"
            xValue={bufferObj.B_URateLc}
            xType={"text"} // text/number/password
            xName={"B_URateLc"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsg.B_URateLc === "" ? false : true}
            xErrorMessage={sErrorMsg.B_URateLc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Gross Amt"
            xtabIndex={"105"}
            xValue={bufferObj.B_GrossAmt}
            xType={"text"} // text/number/password
            xName={"B_GrossAmt"}
            xReadOnly={false}
            xOnChange={fGrossAmt}
            xError={sErrorMsg.B_GrossAmt === "" ? false : true}
            xErrorMessage={sErrorMsg.B_GrossAmt}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.LDisc ? "lastkeyDetect " : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="L.Disc %"
            xtabIndex={"106"}
            xValue={bufferObj.B_LDiscPerc}
            xType={"number"} // text/number/password
            xName={"B_LDiscPerc"}
            xReadOnly={false}
            xOnChange={fonChangeInputLDisc}
            xError={sErrorMsg.B_LDiscPerc === "" ? false : true}
            xErrorMessage={sErrorMsg.B_LDiscPerc}
            xonFocus={(e) => {
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "B_LDiscAmt");
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.LDisc ? "lastkeyDetect " : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="L.Disc Amt"
            xValue={bufferObj.B_LDiscAmt}
            xType={"text"} // text/number/password
            xName={"B_LDiscAmt"}
            xReadOnly={false}
            xOnChange={fonChangeInputLDiscAmt}
            xError={sErrorMsg.B_LDiscAmt === "" ? false : true}
            xErrorMessage={sErrorMsg.B_LDiscAmt}
            xonFocus={(e) => {
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "B_ExciseTaxAmt");
            }}
          />
        </Grid>

        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.TDisc ? "lastkeyDetect " : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="T.Disc %"
            xValue={bufferObj.B_TDiscPerc}
            xType={"text"} // text/number/password
            xName={"B_TDiscPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsg.B_TDiscPerc === "" ? false : true}
            xErrorMessage={sErrorMsg.B_TDiscPerc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.TDisc ? "lastkeyDetect " : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="T.Disc Amt"
            xValue={bufferObj.B_TDiscAmt}
            xType={"text"} // text/number/password
            xName={"B_TDiscAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsg.B_TDiscAmt === "" ? false : true}
            xErrorMessage={sErrorMsg.B_TDiscAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={
            vRdxCheckbox.Foc ? "lastkeyDetect text-center" : "hide-content"
          }
        >
          <div className="d-flex justify-content-center">
            <CmpCheckboxField
              xtabIndex={"107"}
              xChecked={bufferObj?.B_FocFlag === "Y"}
              xOnChange={(e) => {
                fonChangeCheckBoxFoc(e);
              }}
              xDisabled={false}
              xName={"B_FocFlag"}
              xNameField={"FOC"}
              xError={sErrorMsg.B_FocFlag === "" ? false : true}
              xErrorMessage={sErrorMsg.B_FocFlag}
            />
          </div>
        </Grid>

        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Foc ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="FOC Amount"
            xValue={bufferObj.B_FocAmt}
            xType={"text"} // text/number/password
            xName={"B_FocAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsg.B_FocAmt === "" ? false : true}
            xErrorMessage={sErrorMsg.B_FocAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Excise ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Excise"
            xtabIndex={"108"}
            xValue={bufferObj.B_ExciseTaxAmt}
            xType={"number"} // text/number/password
            xName={"B_ExciseTaxAmt"}
            xReadOnly={false}
            xOnChange={(e) => {
              fonChangeInputExcise(e);
            }}
            xError={sErrorMsg.B_ExciseTaxAmt === "" ? false : true}
            xErrorMessage={sErrorMsg.B_ExciseTaxAmt}
            xonFocus={(e) => {
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "Narration");
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Excise ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Net Excise"
            xValue={bufferObj.B_ExciseTaxNetAmt}
            xType={"number"} // text/number/password
            xName={"B_ExciseTaxNetAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsg.B_ExciseTaxNetAmt === "" ? false : true}
            xErrorMessage={sErrorMsg.B_ExciseTaxNetAmt}
            xonFocus={(e) => {
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Taxable ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="TaxableAmt"
            xValue={bufferObj.B_NetAmt}
            xType={"number"} // text/number/password
            xName={"B_NetAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsg.B_NetAmt === "" ? false : true}
            xErrorMessage={sErrorMsg.B_NetAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>

        {/* <Grid item xs={4} sm={2} md={1} lg={1} className={"lastkeyDetect"}>
          <CmpTextFieldV1
            xLabelText="Total"
            xValue={bufferObj.B_LandVal}
            xType={"number"} // text/number/password
            xName={"B_LandVal"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsg.B_LandVal === "" ? false : true}
            xErrorMessage={sErrorMsg.B_LandVal}
            // xOnKeyUp={xKey}
          />
        </Grid> */}

        <Grid
          item
          xs={12}
          sm={3}
          md={2}
          lg={2}
          className={
            vRdxCheckbox.Narration
              ? " lastkeyDetect dropDowntoggle"
              : "hide-content dropDowntoggle"
          }
        >
          <CmpInputFieldGroupV1
            xLabelText="Narration"
            xtabIndex={"111"}
            xValue={bufferObj.Narration}
            xType={"text"} // text/number/password
            xName={"Narration"}
            xReadOnly={false}
            xOnChange={(e) => {
              fonChangeInputNarration(e.target.value);
            }}
            xOnKeyUp={fNarrationKeyEnter}
            xError={sErrorMsg.Narration == "" ? true : false}
            xErrorMessage={sErrorMsg.Narration}
            xTextAlign="start"
            xonFocus={""}
            xonBlur={""}
          />
          {xNarrationToggleDropdown ? (
            <div className="dropDowntoggleAbsolute">
              <GCToggleTableSearch
                xrows={xrowDropdownNarrationSearch}
                xcolumns={xcolumnsDropdownNarrationSearch}
                xRowCellClick={xOnCellKeyNarrationDown}
                xRowClick={xOnRowNarrationClick}
                xMediaQuery={xMediaQuery}
              />
            </div>
          ) : (
            <></>
          )}
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={0.5}
          className="lastkeyDetect"
          display={"flex  "}
          alignItems={"center"}
          justifyContent={"space-around"}
        >
           

          <div>
            
            {xMediaQuery && (
               
               <CmpButtonKWithIcon
               xOnClick={(e) => {
                console.log(xMediaQuery);

                fModalContentOpen(e, "checkboxModal");
              }}
               xDisabled={false}
               xIcon={<VisibilityIcon fontSize={"small"} />}
               xcolor="primary"
             />
            )}
          </div>
        </Grid>
      </Grid>

      <Modal
        open={sOpenContentModal}
        onClose={fModalContentClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className={
            sOpenModalName == "checkboxModal"
              ? "model-content-checkbox"
              : "model-content-Item-Search"
          }
        >
          <div>
            {sOpenModalName == "checkboxModal" ? (
              <>
                <GCTitleSticky
                  title={"Detail list"}
                  onClose={fModalContentClose}
                />

                <div className="container-fluid">
                  <div className="wms-label">
                    <div className="checkbox-mb">
                      <label className="form-label ">
                        <input
                          className="form-check-input "
                          type="checkbox"
                          name="AllChecked"
                          checked={sIsChecked}
                          onChange={(e) => {
                            fIsAllChecked(e);
                          }}
                        />{" "}
                        All
                      </label>
                    </div>
                    <>
                      {vModelCheckboxArr?.map((obj, index) => (
                        <div
                          className="checkbox-mb"
                          key={"Wmscheckbox" + index}
                        >
                          <label className="form-label">
                            <input
                              className="form-check-input "
                              type="checkbox"
                              name={obj.name}
                              checked={obj.rdxName}
                              onChange={(e) => {
                                fSetCheckBox(e);
                              }}
                            />{" "}
                            {obj.name}
                          </label>
                        </div>
                      ))}
                    </>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </Box>
      </Modal>
    </form>
  );
}
